module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-container', {
    staticStyle: {
      "max-width": "1024px"
    }
  }, [_c('div', {
    staticClass: "content elevation-2",
    staticStyle: {
      "padding-top": "8px"
    }
  }, [_c('h1', [_vm._v(_vm._s(this.lng.articlesHeading))]), _vm._v(" "), (_vm.language === 'en') ? _c('div', [_c('v-container', [_c('p', [_vm._v("We do currently not have any articles written in English.")])])], 1) : _vm._e(), _vm._v(" "), (_vm.language === 'de') ? _c('div', [_c('v-container', [_c('a', {
    attrs: {
      "href": "/static/articles/Sparen_LG_DE.pdf",
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "tile noselect"
  }, [_c('picture', [_c('source', {
    attrs: {
      "srcset": "/static/img/article-icons/Sparen-LG.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "haqcs-height elevation-1",
    attrs: {
      "src": "/static/img/article-icons/Sparen-LG.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-container_"
  }, [_c('div', {
    staticClass: "text"
  }, [_c('div', {
    staticClass: "device-title"
  }, [_vm._v("Sparen Lüftungsgeräte wirklich Energie?")]), _vm._v(" "), _c('p', [_vm._v("Natürlich! Aber nicht immer so, wie der Benutzer denkt. Es hängt sehr viel davon ab, wie bewusst er die Lüftungsgeräte einsetzt.")]), _vm._v(" "), _c('p', [_vm._v("Wenn die Luft im Raum beheizt ist (und desto mehr, wenn gekühlt werden muss), geht beim Lüften Energie verloren. Aber es muss gelüftet werden. Deswegen sind ...")]), _vm._v(" "), _c('p', {
    staticClass: "article-date"
  }, [_vm._v("31. März 2022")])])]), _vm._v(" "), _c('div', {
    staticClass: "icon-container_"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('v-icon', [_vm._v("open_in_new")])], 1)])], 1)])])], 1) : _vm._e(), _vm._v(" "), (_vm.language === 'pl') ? _c('div', [_c('v-container', [_c('a', {
    attrs: {
      "href": "/static/articles/Sparen_LG_PL.pdf",
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "tile noselect"
  }, [_c('picture', [_c('source', {
    attrs: {
      "srcset": "/static/img/article-icons/Sparen-LG.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "haqcs-height elevation-1",
    attrs: {
      "src": "/static/img/article-icons/Sparen-LG.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-container_"
  }, [_c('div', {
    staticClass: "text"
  }, [_c('div', {
    staticClass: "device-title"
  }, [_vm._v("Czy rekuperatory oszczędzają rzeczywiście ciepło?")]), _vm._v(" "), _c('p', [_vm._v("Oczywiście! Ale nie zawsze w taki sposób, jak myśli użytkownik. Wiele zależy od tego, jak świadomie korzysta on z urządzeń wentylacyjnych.")]), _vm._v(" "), _c('p', [_vm._v("Jeśli powietrze w pomieszczeniu jest ogrzewane (a tym bardziej, jeśli wymaga schłodzenia), traci się energię podczas wentylacji. Ale wentylacja jest konieczna. Dlatego pojawiły się ...")]), _vm._v(" "), _c('p', {
    staticClass: "article-date"
  }, [_vm._v("31 marca 2022")])])]), _vm._v(" "), _c('div', {
    staticClass: "icon-container_"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('v-icon', [_vm._v("open_in_new")])], 1)])], 1)])])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "64px"
    }
  }), _vm._v(" "), _c('h1', [_vm._v(_vm._s(this.lng.manualsHeading))]), _vm._v(" "), (_vm.language === 'en') ? _c('div', [_c('v-container', [_c('router-link', {
    attrs: {
      "to": "docs/haqcs",
      "tag": "div"
    }
  }, [_c('div', {
    staticClass: "tile noselect"
  }, [_c('picture', [_c('source', {
    attrs: {
      "srcset": "/static/img/offer/haqcs.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "haqcs-height no-shadow",
    attrs: {
      "src": "/static/img/offer/haqcs.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-container_"
  }, [_c('div', {
    staticClass: "text"
  }, [_c('div', {
    staticClass: "device-title"
  }, [_vm._v("Manual for the HAQCS-Monitor")]), _vm._v(" "), _c('p', [_vm._v(" Air quality monitor and controller for decentralized ventilation and humidification. ")])])]), _vm._v(" "), _c('div', {
    staticClass: "icon-container_"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('v-icon', [_vm._v("chevron_right")])], 1)])], 1)])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.language === 'de') ? _c('div', [_c('v-container', [_c('router-link', {
    attrs: {
      "to": "dokumentation/haqcs",
      "tag": "div"
    }
  }, [_c('div', {
    staticClass: "tile noselect"
  }, [_c('picture', [_c('source', {
    attrs: {
      "srcset": "/static/img/offer/haqcs.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "haqcs-height no-shadow",
    attrs: {
      "src": "/static/img/offer/haqcs.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-container_"
  }, [_c('div', {
    staticClass: "text"
  }, [_c('div', {
    staticClass: "device-title"
  }, [_vm._v("Anleitung für den HAQCS-Monitor")]), _vm._v(" "), _c('p', [_vm._v("Luftqualitäts-Monitor und intelligente Lüftungssteuerung in einem Gerät. Seine Sensoren erfassen CO"), _c('sub', [_vm._v("2")]), _vm._v(", VOC und Klimawerte. Er zeigt die Luftqualität an, alarmiert und regelt bedarfsgerecht die dezentrale Lüftung.")])])]), _vm._v(" "), _c('div', {
    staticClass: "icon-container_"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('v-icon', [_vm._v("chevron_right")])], 1)])], 1)])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.language === 'pl') ? _c('div', [_c('v-container', [_c('router-link', {
    attrs: {
      "to": "dokumentacja/haqcs",
      "tag": "div"
    }
  }, [_c('div', {
    staticClass: "tile noselect"
  }, [_c('picture', [_c('source', {
    attrs: {
      "srcset": "/static/img/offer/haqcs.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "haqcs-height no-shadow",
    attrs: {
      "src": "/static/img/offer/haqcs.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-container_"
  }, [_c('div', {
    staticClass: "text"
  }, [_c('div', {
    staticClass: "device-title"
  }, [_vm._v("Instrukcja dla HAQCS-Monitora")]), _vm._v(" "), _c('p', [_vm._v("Monitor jekości powietrza i automatyczny sterownik wentylacji i nawilżania.")])])]), _vm._v(" "), _c('div', {
    staticClass: "icon-container_"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('v-icon', [_vm._v("chevron_right")])], 1)])], 1)])], 1)], 1) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "50vh"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-54484697"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dokumentation.vue
// module id = 158
// module chunks = 1 2